import { getMapView } from '@/map/mapStore';
import type { Tool } from './types';

type Input = { title?: string };

export const printMap: Tool<Input> = {
  name: 'print_map',
  description:
    'Capture the current map view as a PNG and trigger a download in the renderer. Returns the filename used.',
  input_schema: {
    type: 'object',
    properties: { title: { type: 'string' } },
    additionalProperties: false,
  },
  execute: async ({ title } = {}) => {
    const view = getMapView();
    if (!view) throw new Error('print_map: map not initialised');
    const screenshot = await view.takeScreenshot({ format: 'png' });
    const filename = `${slug(title ?? 'rcmc-map')}-${stamp()}.png`;
    download(screenshot.dataUrl, filename);
    return { filename, format: 'png' };
  },
};

function slug(s: string): string {
  return (
    s
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'map'
  );
}

function stamp(): string {
  const d = new Date();
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}-${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

function download(href: string, filename: string): void {
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
